import { LayoutDirection, PercentageDisplayMode } from '../types';

export interface AppSettings {
  showGrid: boolean;
  layoutDirection: LayoutDirection;
  showCountryFlags: boolean;
  percentageDisplayMode: PercentageDisplayMode;
  showSingleShareholder: boolean;
  showDirectors: boolean;
  clusterGrouping: boolean;
}

export const DEFAULT_SETTINGS: AppSettings = {
  showGrid: true,
  layoutDirection: 'TB',
  showCountryFlags: true,
  percentageDisplayMode: 'card',
  showSingleShareholder: true,
  showDirectors: true,
  clusterGrouping: true, // default aan, want compound nodes maken het correct
};

const STORAGE_KEY = 'hvg-settings-v1';

export function loadSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_SETTINGS, ...parsed };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(s: AppSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
  } catch {
    /* ignore */
  }
}
